// Actions
export const MATERIAL_FETCH  = '[Material] Fetch'

// Mutations
export const MATERIAL_META   = '[Material] meta'
export const MATERIAL_OBTAIN = '[Material] obtain'
export const MATERIAL_CLEAR  = '[Material] clear'
export const MATERIAL_SET_LOADING = '[Material] set loading'
